import React, { useState } from 'react';
import { Route } from 'react-router-dom';
import authService from '../services/auth'
import { LoadingCircular } from './presentational/loading.jsx';

function PrivateRoute({ component: Component, children, ...rest }) {

  const [logged, setLogged] = useState(undefined)

  async function setLoggedInStatus() {
    try {
      await authService.verifyUserLoggedIn()
      setLogged(true)
    } catch (error) {
      setLogged(false)
    }
  }

  if (logged === undefined){
    setLoggedInStatus()
  }

  if (logged === undefined) {
    return (
      <LoadingCircular></LoadingCircular>
    )
  }

  if (logged === false) {
    const location = rest.location.pathname
    const search = rest.location.search
    const url = encodeURI('/auth/login?bounceTo=' + (location + search))
    return (
      <Route component={() => {
        window.location = url;
        return null;

      }} />
    )
  }

  if (logged === true) {
    return (
      <Route
        {...rest}
        render={props =>
          <Component {...props} />
        }
      />
    )
  }
}

export default PrivateRoute
